(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2312],{

/***/ 82254:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/expert",
      function () {
        return __webpack_require__(5057);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5057:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ expert; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/component/home/renewal/main/pc/MainLayout.tsx
var MainLayout = __webpack_require__(63286);
// EXTERNAL MODULE: ./src/component/home/renewal/main/mobile/MainFooterMobile.tsx
var MainFooterMobile = __webpack_require__(40191);
// EXTERNAL MODULE: ./src/component/home/renewal/main/mobile/MainGnbMobile.tsx + 1 modules
var MainGnbMobile = __webpack_require__(43775);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 3 modules
var emotion_styled_browser_esm = __webpack_require__(77366);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(61225);
// EXTERNAL MODULE: ./src/component/base/WebpImage.tsx
var WebpImage = __webpack_require__(76445);
// EXTERNAL MODULE: ./src/component/SignComponent.tsx
var SignComponent = __webpack_require__(34489);
// EXTERNAL MODULE: ./src/hook/useUser.ts + 1 modules
var useUser = __webpack_require__(92859);
// EXTERNAL MODULE: ./src/model/applicationModel.ts
var applicationModel = __webpack_require__(21594);
// EXTERNAL MODULE: ./src/ruix/index.ts + 22 modules
var ruix = __webpack_require__(9869);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swiper/modules/index.mjs + 27 modules
var modules = __webpack_require__(94135);
// EXTERNAL MODULE: ./node_modules/swiper/swiper-react.mjs + 2 modules
var swiper_react = __webpack_require__(48929);
// EXTERNAL MODULE: ./src/component/home/renewal/base/BaseContents.tsx
var BaseContents = __webpack_require__(17805);
// EXTERNAL MODULE: ./src/component/home/renewal/main/pc/MainContents.tsx
var MainContents = __webpack_require__(33827);
;// CONCATENATED MODULE: ./src/component/home/renewal/expert/mobile/ExpertContentsMobile.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	flex: 1;\n	padding: 16px 10px;\n	width: 100%;\n	align-items: center;\n	justify-content: flex-start;\n	width: 100%;\n	gap: 8px;\n	border-radius: 4px;\n\n	.title {\n		color: var(--card-bg);\n		font-family: Pretendard;\n		font-size: 20px;\n		font-style: normal;\n		font-weight: 700;\n		line-height: 130%; /* 31.2px */\n		letter-spacing: -0.72px;\n	}\n\n	.subTitle {\n		color: var(--desc-gray);\n		font-family: Pretendard;\n		font-size: 16px;\n		font-style: normal;\n		font-weight: 500;\n		line-height: 150%; /* 30px */\n		letter-spacing: -0.8px;\n	}\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}














var ExpertContentsMobile = function() {
    var user = (0,useUser/* default */.Z)().user;
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(0), lastScrollTop = ref[0], setLastScrollTop = ref[1];
    var isScrollingUp = function() {
        var currentScrollTop = window.scrollY;
        var scrollingUp = currentScrollTop < lastScrollTop;
        setLastScrollTop(currentScrollTop <= 0 ? 0 : currentScrollTop);
        return scrollingUp;
    };
    (0,react.useEffect)(function() {
        var scrollFunction = function() {
            var ref;
            if (scrollY > ((ref = document.querySelector("#expert-apply-mid")) === null || ref === void 0 ? void 0 : ref.offsetHeight) && !isScrollingUp()) {
                var ref1;
                (ref1 = document.querySelector("#floating-btn")) === null || ref1 === void 0 ? void 0 : ref1.classList.remove("hidden");
            } else {
                var ref2;
                (ref2 = document.querySelector("#floating-btn")) === null || ref2 === void 0 ? void 0 : ref2.classList.add("hidden");
            }
        };
        window.addEventListener("scroll", scrollFunction);
        return function() {
            window === null || window === void 0 ? void 0 : window.removeEventListener("scroll", scrollFunction);
        };
    }, [
        lastScrollTop
    ]);
    var 플로팅버튼 = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: function() {
                    router.push("/match/my?type=expert");
                },
                id: "floating-btn",
                className: "hidden",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: "지금 바로 지원하기"
                })
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseContents/* ExpertMainContentsContainerMobile */.vA, {
            className: "column-center-start",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MainCtaContents, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TrustSection, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewSection, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(WhyOnePoint, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(OnePointResponsibility, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Process, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CIList, {}),
                플로팅버튼(),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MainContents/* FAQSection */.v, {
                    list: applicationModel/* faqListExpert.0 */.SP[0]
                })
            ]
        })
    });
};
var MainCtaContents = function() {
    var user = (0,useUser/* default */.Z)().user;
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseContents/* ExpertCtaContentsContainer */.rm, {
        className: "column-center-center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseContents/* ContentsContainerMobile */.ix, {
            className: "column-center-center",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseContents/* ExpertCtaContentsInnerMobile */.DA, {
                className: "column-center-start",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                        className: "cta-title-box",
                        style: {
                            margin: "0 auto"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "row-center-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "상위 10% 마케터를 위한"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "row-center-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "프리랜서 플랫폼"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseContents/* ExpertMainCtaButtonMobile */._B, {
                        variant: "outlined",
                        id: "expert-apply-mid",
                        onClick: function() {
                            router.push("/match/my?type=expert");
                        },
                        children: "지금 바로 지원하기"
                    })
                ]
            })
        })
    });
};
var WhyOnePointSections = function() {
    var a = 1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: BaseContents/* ExpertWhyOnpointData.map */.X5.map(function(section, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SignComponent/* EmptySpace */.zV, {
                        space: 40
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseContents/* WhyOnePointBox */._N, {
                        className: "column-center-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseContents/* WhyOnePointDiv */.Xf, {
                            className: "column-center-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "label",
                                    style: {
                                        textAlign: "center"
                                    },
                                    children: section.label
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(WebpImage/* default */.Z, {
                                    width: 120,
                                    src: section.image,
                                    alt: section.label
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        textAlign: "center"
                                    },
                                    className: "title",
                                    children: section.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        textAlign: "center"
                                    },
                                    className: "description",
                                    children: section.description.split("\n").map(function(line, i) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                            children: [
                                                line,
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                            ]
                                        }, i);
                                    })
                                })
                            ]
                        })
                    })
                ]
            }, index);
        })
    });
};
var WhyOnePoint = function() {
    var a = 1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseContents/* ContentsContainerMobile */.ix, {
        className: "column-center-start",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseContents/* SectionTitleMobile */.yb, {
                children: "왜 원포인트 인가요?"
            }),
            WhyOnePointSections()
        ]
    });
};
var OnePointResponsibility = function() {
    var a = 1;
    var isPc = (0,useMediaQuery/* default */.Z)("(min-width: 1024px)");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseContents/* ContentsContainerMobile */.ix, {
        className: "column-center-start",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseContents/* SectionTitleMobile */.yb, {
                children: "원포인트가\n확실히 책임져요"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SignComponent/* EmptySpace */.zV, {
                space: 40
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ruix/* GroupA */.so, {
                order: isPc ? "row-center-center" : "column-center-center",
                gap: 32,
                children: BaseContents/* ResponsibilityData.map */.Tb.map(function(data, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseContents/* ResponsibilityCard */.dV, {
                        className: "column-center-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(WebpImage/* default */.Z, {
                                className: "responsibility-img",
                                src: data.image,
                                alt: data.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "title",
                                style: {
                                    textAlign: "center"
                                },
                                children: data.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "desc",
                                style: {
                                    textAlign: "center"
                                },
                                children: data.desc
                            })
                        ]
                    }, index);
                })
            })
        ]
    });
};
var ReviewSection = function() {
    var chunkArray = function(array, size) {
        return array.reduce(function(acc, _, index) {
            if (index % size === 0) acc.push(array.slice(index, index + size));
            return acc;
        }, []);
    };
    // 3개씩 그룹으로 나누기
    var groupedData = chunkArray(BaseContents/* ExpertReviewData */.ex, 1);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseContents/* ContentsContainerMobile */.ix, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseContents/* ReviewContainer */.b_, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                    modules: [
                        modules/* Pagination */.tl,
                        modules/* Scrollbar */.LW,
                        modules/* Autoplay */.pt
                    ],
                    slidesPerView: 1,
                    slidesPerGroup: 1,
                    centeredSlides: false,
                    loop: true,
                    spaceBetween: 20,
                    pagination: {
                        clickable: true,
                        el: ".c-list-pagination2"
                    },
                    autoplay: {
                        delay: 3000,
                        disableOnInteraction: true,
                        pauseOnMouseEnter: true
                    },
                    breakpoints: {
                        820: {
                            slidesPerView: 3,
                            slidesPerGroup: 3,
                            spaceBetween: 20,
                            centeredSlides: false,
                            autoplay: {
                                delay: 5000,
                                disableOnInteraction: true,
                                pauseOnMouseEnter: true
                            }
                        }
                    },
                    children: groupedData.map(function(group, i) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "card-container column-center-center",
                                style: {
                                    gap: 10
                                },
                                children: group.map(function(v, j) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseContents/* ExpertReviewCard */.F7, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ruix/* GroupA */.so, {
                                            order: "column-center-start",
                                            gap: 16,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ruix/* GroupA */.so, {
                                                    order: "column-center-start",
                                                    gap: 8,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "title",
                                                            children: v.title
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "desc",
                                                            children: v.description
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ruix/* GroupA */.so, {
                                                    order: "column-start-start",
                                                    gap: 8,
                                                    fullWidth: true,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "name row-center-center",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                children: v.position
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "name-gray",
                                                                children: v.name
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    }, "review-".concat(i, "-").concat(j));
                                })
                            })
                        }, "review-group-".concat(i));
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SignComponent/* EmptySpace */.zV, {
                space: 24
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseContents/* CListPagination */.VH, {
                className: "c-list-pagination2 row-center-center"
            })
        ]
    });
};
var Process = function() {
    var isPc = (0,useMediaQuery/* default */.Z)("(min-width: 1024px)");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseContents/* ContentsContainerMobile */.ix, {
        className: "column-center-start",
        style: {
            padding: "64px 0",
            background: "var(--bg-white)"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ruix/* GroupA */.so, {
                order: "column-center-center",
                gap: 0,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseContents/* SectionTitleMobile */.yb, {
                        children: "등록 프로세스"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseContents/* SectionSubTitleMobile */.hA, {
                        children: "3단계 프로세스로\n하드 및 소프트 스킬을 검증합니다"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SignComponent/* EmptySpace */.zV, {
                space: 40
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ruix/* GroupA */.so, {
                order: "column-start-start",
                gap: 16,
                fullWidth: true,
                children: BaseContents/* ExpertProcessCardListMobile.map */.ip.map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(WhyCard, {
                        imgSrc: item.imgSrc,
                        title: item.title,
                        subTitle: item.subTitle
                    }, "ExpertProcessCard" + index);
                })
            })
        ]
    });
};
var WhyCard = function(props) {
    var imgSrc = props.imgSrc, title = props.title, subTitle = props.subTitle;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(WhyCardBoxMobile, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WebpImage/* default */.Z, {
                style: {
                    width: "56px",
                    height: "56px"
                },
                src: imgSrc,
                alt: ""
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ruix/* GroupA */.so, {
                order: "column-start-start",
                gap: 0,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "title",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "subTitle",
                        children: subTitle
                    })
                ]
            })
        ]
    });
};
var WhyCardBoxMobile = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject());
var TrustSection = function() {
    var a = 1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseContents/* ContentsContainerMobile */.ix, {
        className: "column-start-start",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ruix/* GroupA */.so, {
                fullWidth: true,
                order: "column-center-center",
                gap: 0,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseContents/* FAQAnswerDiv */.Qf, {
                        children: "왜 프리랜서로 일해야 하나요?"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ruix/* Empty */.HY, {
                        space: 20
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseContents/* SectionTitleMobile */.yb, {
                        children: "잘하는 일로 수입도 만들고"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseContents/* SectionTitleMobile */.yb, {
                        children: "더 성장하고 싶다면"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ruix/* Empty */.HY, {
                space: 20
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ruix/* GroupA */.so, {
                fullWidth: true,
                order: "column-center-center",
                gap: 8,
                children: BaseContents/* TrustData.map */.jW.map(function(data, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseContents/* ExpertTrustCard */.px, {
                        className: "column-center-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ruix/* GroupA */.so, {
                                order: "row-center-center",
                                gap: 0,
                                fullWidth: true,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "num",
                                        children: data.num
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "numstr",
                                        children: data.numstr
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "title",
                                children: data.title
                            })
                        ]
                    }, index);
                })
            })
        ]
    });
};
var CIList = function() {
    //
    var a = 1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseContents/* ContentsContainerMobile */.ix, {
        className: "column-center-start",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseContents/* SectionTitleMobile */.yb, {
                children: "성장하는 기업과 함께하세요"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SignComponent/* EmptySpace */.zV, {
                space: 40
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseContents/* CIListContainer */.jy, {
                className: "row-center-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WebpImage/* default */.Z, {
                        src: "/onepoint/images/renewal/ci-section/1-1.png",
                        alt: "company1-1"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WebpImage/* default */.Z, {
                        src: "/onepoint/images/renewal/ci-section/1-2.png",
                        alt: "company1-2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WebpImage/* default */.Z, {
                        src: "/onepoint/images/renewal/ci-section/1-3.png",
                        alt: "company1-3"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WebpImage/* default */.Z, {
                        src: "/onepoint/images/renewal/ci-section/1-4.png",
                        alt: "company1-4"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WebpImage/* default */.Z, {
                        src: "/onepoint/images/renewal/ci-section/1-5.png",
                        alt: "company1-5"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WebpImage/* default */.Z, {
                        src: "/onepoint/images/renewal/ci-section/1-6.png",
                        alt: "company1-6"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WebpImage/* default */.Z, {
                        src: "/onepoint/images/renewal/ci-section/1-7.png",
                        alt: "company1-7"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WebpImage/* default */.Z, {
                        src: "/onepoint/images/renewal/ci-section/1-8.png",
                        alt: "company1-8"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WebpImage/* default */.Z, {
                        src: "/onepoint/images/renewal/ci-section/2-1.png",
                        alt: "company2-1"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WebpImage/* default */.Z, {
                        src: "/onepoint/images/renewal/ci-section/2-2.png",
                        alt: "company2-2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WebpImage/* default */.Z, {
                        src: "/onepoint/images/renewal/ci-section/2-3.png",
                        alt: "company2-3"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WebpImage/* default */.Z, {
                        src: "/onepoint/images/renewal/ci-section/2-4.png",
                        alt: "company2-4"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SignComponent/* EmptySpace */.zV, {
                space: 60
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/component/home/renewal/expert/mobile/ExpertPageMobile.tsx





var ExpertPageMobile = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MainLayout/* MainLayout */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MainGnbMobile/* MainGnbMobile */.j, {
                type: "expert"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpertContentsMobile, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MainFooterMobile/* MainFooterMobile */.w, {})
        ]
    });
};
/* harmony default export */ var mobile_ExpertPageMobile = (ExpertPageMobile);

// EXTERNAL MODULE: ./src/component/home/renewal/main/pc/MainFooter.tsx
var MainFooter = __webpack_require__(62579);
// EXTERNAL MODULE: ./src/component/home/renewal/main/pc/MainGnb.tsx
var MainGnb = __webpack_require__(9561);
;// CONCATENATED MODULE: ./src/component/home/renewal/expert/pc/ExpertContents.tsx













var ExpertContents = function() {
    var user = (0,useUser/* default */.Z)().user;
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(0), lastScrollTop = ref[0], setLastScrollTop = ref[1];
    var isScrollingUp = function() {
        var currentScrollTop = window.scrollY;
        var scrollingUp = currentScrollTop < lastScrollTop;
        setLastScrollTop(currentScrollTop <= 0 ? 0 : currentScrollTop);
        return scrollingUp;
    };
    (0,react.useEffect)(function() {
        var scrollFunction = function() {
            var ref;
            if (scrollY > ((ref = document.querySelector("#expert-apply-mid")) === null || ref === void 0 ? void 0 : ref.offsetHeight) && !isScrollingUp()) {
                var ref1;
                (ref1 = document.querySelector("#floating-btn")) === null || ref1 === void 0 ? void 0 : ref1.classList.remove("hidden");
            } else {
                var ref2;
                (ref2 = document.querySelector("#floating-btn")) === null || ref2 === void 0 ? void 0 : ref2.classList.add("hidden");
            }
        };
        window.addEventListener("scroll", scrollFunction);
        return function() {
            window === null || window === void 0 ? void 0 : window.removeEventListener("scroll", scrollFunction);
        };
    }, [
        lastScrollTop
    ]);
    var 플로팅버튼 = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: function() {
                    router.push("/match/my?type=expert");
                },
                id: "floating-btn",
                className: "hidden",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: "지금 바로 지원하기"
                })
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseContents/* MainContentsContainer */.AF, {
            className: "column-center-start",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpertContents_MainCtaContents, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpertContents_TrustSection, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpertContents_ReviewSection, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpertContents_WhyOnePoint, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpertContents_OnePointResponsibility, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpertContents_Process, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpertContents_CIList, {}),
                플로팅버튼(),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MainContents/* FAQSection */.v, {
                    list: applicationModel/* faqListExpert.0 */.SP[0]
                })
            ]
        })
    });
};
var ExpertContents_MainCtaContents = function() {
    var user = (0,useUser/* default */.Z)().user;
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseContents/* ExpertCtaContentsContainer */.rm, {
        className: "column-center-center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseContents/* ContentsContainer */.y3, {
            className: "column-center-center",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseContents/* ExpertCtaContentsInner */.OX, {
                className: "column-center-start",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                        className: "cta-title-box",
                        style: {
                            margin: "0 auto"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "row-center-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "상위 10% 마케터를 위한"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "row-center-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "프리랜서 플랫폼"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseContents/* ExpertMainCtaButton */.Bi, {
                        variant: "outlined",
                        id: "expert-apply-mid",
                        onClick: function() {
                            router.push("/match/my?type=expert");
                        },
                        children: "지금 바로 지원하기"
                    })
                ]
            })
        })
    });
};
var ExpertContents_WhyOnePointSections = function() {
    var a = 1;
    var isPc = (0,useMediaQuery/* default */.Z)("(min-width: 768px)");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: BaseContents/* ExpertWhyOnpointData.map */.X5.map(function(section, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SignComponent/* EmptySpace */.zV, {
                        space: 40
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseContents/* WhyOnePointBox */._N, {
                        className: isPc ? "row-center-between" : "row-center-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseContents/* WhyOnePointDiv */.Xf, {
                                className: "column-start-start",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "label",
                                        children: section.label
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "title",
                                        children: section.title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "description",
                                        children: section.description.split("\n").map(function(line, i) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                                children: [
                                                    line,
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                                ]
                                            }, i);
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(WebpImage/* default */.Z, {
                                width: 240,
                                src: section.image,
                                alt: section.label
                            })
                        ]
                    })
                ]
            }, index);
        })
    });
};
var ExpertContents_WhyOnePoint = function() {
    var a = 1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseContents/* ContentsContainer */.y3, {
        className: "column-center-start",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseContents/* SectionTitle */.NZ, {
                children: "왜 원포인트 인가요?"
            }),
            ExpertContents_WhyOnePointSections()
        ]
    });
};
var ExpertContents_OnePointResponsibility = function() {
    var a = 1;
    var isPc = (0,useMediaQuery/* default */.Z)("(min-width: 1024px)");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseContents/* ContentsContainer */.y3, {
        className: "column-center-start",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseContents/* SectionTitle */.NZ, {
                children: "원포인트가 확실히 책임져요"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SignComponent/* EmptySpace */.zV, {
                space: 40
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ruix/* GroupA */.so, {
                order: isPc ? "row-center-center" : "column-center-center",
                gap: 32,
                children: BaseContents/* ResponsibilityData.map */.Tb.map(function(data, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseContents/* ResponsibilityCard */.dV, {
                        className: "column-start-start",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(WebpImage/* default */.Z, {
                                className: "responsibility-img",
                                src: data.image,
                                alt: data.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "title",
                                children: data.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "desc",
                                children: data.desc
                            })
                        ]
                    }, index);
                })
            })
        ]
    });
};
var ExpertContents_ReviewSection = function() {
    var a = 1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseContents/* ContentsContainer */.y3, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseContents/* ReviewContainer */.b_, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                    modules: [
                        modules/* Pagination */.tl,
                        modules/* Scrollbar */.LW,
                        modules/* Autoplay */.pt
                    ],
                    slidesPerView: 1,
                    slidesPerGroup: 1,
                    centeredSlides: false,
                    loop: true,
                    spaceBetween: 20,
                    pagination: {
                        clickable: true,
                        el: ".c-list-pagination2"
                    },
                    autoplay: {
                        delay: 3000,
                        disableOnInteraction: true,
                        pauseOnMouseEnter: true
                    },
                    breakpoints: {
                        820: {
                            slidesPerView: 3,
                            slidesPerGroup: 3,
                            spaceBetween: 20,
                            centeredSlides: false,
                            autoplay: {
                                delay: 5000,
                                disableOnInteraction: true,
                                pauseOnMouseEnter: true
                            }
                        }
                    },
                    children: BaseContents/* ExpertReviewData.map */.ex.map(function(v, i) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseContents/* ExpertReviewCard */.F7, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ruix/* GroupA */.so, {
                                    order: "column-center-start",
                                    gap: 16,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ruix/* GroupA */.so, {
                                            order: "column-center-start",
                                            gap: 8,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "title",
                                                    children: v.title
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "desc",
                                                    children: v.description
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ruix/* GroupA */.so, {
                                            order: "column-start-start",
                                            gap: 8,
                                            fullWidth: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "name row-center-center",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: v.position
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "name-gray",
                                                        children: v.name
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            })
                        }, "review-".concat(i));
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SignComponent/* EmptySpace */.zV, {
                space: 24
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseContents/* CListPagination */.VH, {
                className: "c-list-pagination2 row-center-center"
            })
        ]
    });
};
var ExpertContents_Process = function() {
    var isPc = (0,useMediaQuery/* default */.Z)("(min-width: 1024px)");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseContents/* ContentsContainer */.y3, {
        className: "column-center-start",
        style: {
            background: "var(--bg-white)",
            padding: "64px 0"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ruix/* GroupA */.so, {
                order: "column-center-center",
                gap: 0,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseContents/* SectionTitle */.NZ, {
                        children: "등록 프로세스"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseContents/* SectionSubTitle */.Vm, {
                        children: "3단계 프로세스로 하드 및 소프트 스킬을 검증합니다"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SignComponent/* EmptySpace */.zV, {
                space: 40
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ruix/* GroupA */.so, {
                order: isPc ? "row-start-between" : "column-center-center",
                gap: 16,
                children: BaseContents/* ExpertProcessCardList.map */.$K.map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseContents/* ExpertProcessCard */.ZK, {
                        imgSrc: item.imgSrc,
                        title: item.title,
                        subTitle: item.subTitle
                    }, "ExpertProcessCard" + index);
                })
            })
        ]
    });
};
var ExpertContents_TrustSection = function() {
    var a = 1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseContents/* ContentsContainer */.y3, {
        className: "column-start-start",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ruix/* GroupA */.so, {
                fullWidth: true,
                order: "column-center-center",
                gap: 0,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseContents/* FAQAnswerDiv2 */.wt, {
                        children: "왜 프리랜서로 일해야 하나요?"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ruix/* Empty */.HY, {
                        space: 20
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseContents/* SectionTitle */.NZ, {
                        children: "잘하는 일로 수입도 만들고"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseContents/* SectionTitle */.NZ, {
                        children: "더 성장하고 싶다면"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ruix/* Empty */.HY, {
                space: 20
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ruix/* GroupA */.so, {
                order: "row-center-center",
                gap: 8,
                children: BaseContents/* TrustData.map */.jW.map(function(data, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseContents/* ExpertTrustCard */.px, {
                        className: "column-center-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ruix/* GroupA */.so, {
                                order: "row-center-center",
                                gap: 0,
                                fullWidth: true,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "num",
                                        children: data.num
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "numstr",
                                        children: data.numstr
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "title",
                                children: data.title
                            })
                        ]
                    }, index);
                })
            })
        ]
    });
};
var ExpertContents_CIList = function() {
    //
    var a = 1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseContents/* ContentsContainer */.y3, {
        className: "column-center-start",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseContents/* SectionTitle */.NZ, {
                children: "성장하는 기업과 함께하세요"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SignComponent/* EmptySpace */.zV, {
                space: 40
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseContents/* CIListContainer */.jy, {
                className: "row-center-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WebpImage/* default */.Z, {
                        src: "/onepoint/images/renewal/ci-section/1-1.png",
                        alt: "company1-1"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WebpImage/* default */.Z, {
                        src: "/onepoint/images/renewal/ci-section/1-2.png",
                        alt: "company1-2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WebpImage/* default */.Z, {
                        src: "/onepoint/images/renewal/ci-section/1-3.png",
                        alt: "company1-3"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WebpImage/* default */.Z, {
                        src: "/onepoint/images/renewal/ci-section/1-4.png",
                        alt: "company1-4"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WebpImage/* default */.Z, {
                        src: "/onepoint/images/renewal/ci-section/1-5.png",
                        alt: "company1-5"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WebpImage/* default */.Z, {
                        src: "/onepoint/images/renewal/ci-section/1-6.png",
                        alt: "company1-6"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WebpImage/* default */.Z, {
                        src: "/onepoint/images/renewal/ci-section/1-7.png",
                        alt: "company1-7"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WebpImage/* default */.Z, {
                        src: "/onepoint/images/renewal/ci-section/1-8.png",
                        alt: "company1-8"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WebpImage/* default */.Z, {
                        src: "/onepoint/images/renewal/ci-section/2-1.png",
                        alt: "company2-1"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WebpImage/* default */.Z, {
                        src: "/onepoint/images/renewal/ci-section/2-2.png",
                        alt: "company2-2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WebpImage/* default */.Z, {
                        src: "/onepoint/images/renewal/ci-section/2-3.png",
                        alt: "company2-3"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WebpImage/* default */.Z, {
                        src: "/onepoint/images/renewal/ci-section/2-4.png",
                        alt: "company2-4"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SignComponent/* EmptySpace */.zV, {
                space: 60
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/component/home/renewal/expert/pc/ExpertPage.tsx





var ExpertPage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MainLayout/* MainLayout */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MainGnb/* MainGnb */.F, {
                type: "expert"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpertContents, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MainFooter/* MainFooter */.j, {})
        ]
    });
};
/* harmony default export */ var pc_ExpertPage = (ExpertPage);

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./pages/expert/index.tsx







var faqStructuredData = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
        {
            "@type": "Question",
            name: "현재 재직중인데 전문가로 활동할 수 있을까요?",
            acceptedAnswer: {
                "@type": "Answer",
                text: "가능합니다. 실제로 대다수의 원포인트 전문가분들이 현직자로서 원포인트 서비스를 수행하고 계십니다. 단, 현 직장에서 정해진 근무 시간이 있는 경우 해당 시간을 반드시 피해서 활동하셔야 합니다."
            }
        },
        {
            "@type": "Question",
            name: "재직중인 혹은 재직했던 회사 이력을 마스킹 처리할 수 있을까요?",
            acceptedAnswer: {
                "@type": "Answer",
                text: "특정 이력에 대한 마스킹이 필요한 경우 프로필 작성 시 아래와 같이 입력할 수 있습니다.\n예) 롸잇 → 탑티어 마케터 단기 고용 서비스 O사\n단, 고객사는 전문가님의 프로필을 토대로 의사결정을 하기 때문에 마스킹을 하지 않거나 최소한으로 처리하시는 것을 추천드립니다."
            }
        },
        {
            "@type": "Question",
            name: "어떤 직무로 전문가 지원이 가능한가요?",
            acceptedAnswer: {
                "@type": "Answer",
                text: "마케팅과 관련된 직무는 어떤 직무든 가능합니다. 퍼포먼스 마케터, 콘텐츠 마케터, 브랜드 마케터, CRM 마케터, 디자이너, 카피라이터가 대표적인 예입니다."
            }
        },
        {
            "@type": "Question",
            name: "근무는 어떤 형태로 진행되나요?",
            acceptedAnswer: {
                "@type": "Answer",
                text: "대부분의 경우 비대면 형태로 업무하지만, 고객사 측에서 희망하는 경우 전문가와의 협의 하에 대면 또는 혼합 (대면+비대면) 근무로 진행됩니다. 업무 형태는 고객사의 업무 공고에서 확인할 수 있습니다."
            }
        },
        {
            "@type": "Question",
            name: "고객사와의 매칭은 어떻게 진행되나요?",
            acceptedAnswer: {
                "@type": "Answer",
                text: "다양한 고객사의 업무 공고를 확인하고, 내가 원하는 곳에 원하는 만큼 지원할 수 있습니다. 사전에 프로필을 작성해두시면 빠르고 쉽게 지원할 수 있습니다."
            }
        },
        {
            "@type": "Question",
            name: "매칭 이후 서비스 시작까지 어떤 절차를 거치나요?",
            acceptedAnswer: {
                "@type": "Answer",
                text: "고객사와의 Fit 검증을 위한 인터뷰 이후, 진행 의사가 있을시 제안서를 작성해주시면 고객사가 내용을 검토합니다. 고객사 최종 의사 결정까지는 보통 인터뷰 진행 후 영업일 기준 5일 정도 소요됩니다."
            }
        }, 
    ]
};
var ProHome = function(props) {
    var ref = (0,react.useState)(props.isPc), isPc = ref[0], setIsPc = ref[1];
    (0,react.useEffect)(function() {
        var handleResize = function() {
            if (window.innerWidth >= 1024) {
                setIsPc(true);
            } else {
                setIsPc(false);
            }
        };
        window.addEventListener("resize", handleResize);
        handleResize();
        return function() {
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    var structuredData = {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [
            {
                "@type": "ListItem",
                position: 1,
                name: "Home",
                item: "https://1point.kr"
            },
            {
                "@type": "ListItem",
                position: 2,
                name: "전문가",
                item: "https://1point.kr/expert/"
            }, 
        ]
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: "https://1point.kr/expert/"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: {
                            __html: JSON.stringify(structuredData)
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: {
                            __html: JSON.stringify(faqStructuredData)
                        }
                    })
                ]
            }),
            isPc ? /*#__PURE__*/ (0,jsx_runtime.jsx)(pc_ExpertPage, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_ExpertPageMobile, {})
        ]
    });
};
ProHome.getInitialProps = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var req, isPc, userAgent, userAgent1, result, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            req = param.req;
            isPc = false;
            if (req) {
                userAgent = req.headers["user-agent"];
                isPc = /Windows|Macintosh|Linux/i.test(userAgent);
            } else {
                userAgent1 = navigator.userAgent;
                isPc = /Windows|Macintosh|Linux/i.test(userAgent1);
            }
            _tmp = {};
            result = (_tmp.meta = {
                title: "탑티어 마케터를 위한 프리랜서 플랫폼 - 원포인트",
                metaTitle: "탑티어 마케터를 위한 프리랜서 플랫폼 - 원포인트",
                metaDescription: "원포인트(One Point)는 업계 탑티어 마케터를 위한 프리랜서 플랫폼입니다.",
                metaOgType: "website",
                metaOgTitle: "탑티어 마케터를 위한 프리랜서 플랫폼 - 원포인트",
                metaOgDescription: "원포인트(One Point)는 업계 탑티어 마케터를 위한 프리랜서 플랫폼입니다.",
                metaOgUrl: "https://1point.kr/expert/",
                metaTwitterCard: "summary",
                metaTwitterTitle: "탑티어 마케터를 위한 프리랜서 플랫폼 - 원포인트",
                metaTwitterDescription: "원포인트(One Point)는 업계 탑티어 마케터를 위한 프리랜서 플랫폼입니다."
            }, _tmp.isPc = isPc, _tmp);
            return [
                2,
                result
            ];
        });
    });
    return function(_) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var expert = (ProHome);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3978,9522,4170,8068,1088,6371,3827,1272,9774,2888,179], function() { return __webpack_exec__(82254); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);